import { GmailIcon, GoogleCalendarIcon } from '../components/icons';
import { E_MultiplayerServiceName } from '@repo-sapiens/data-access-models';

export enum ENotificationKey {
  SHOW_DROPDOWN = 'SHOW_DROPDOWN',
  SHOW_LOGOUT = 'SHOW_LOGOUT',
  UPDATE_TASK = 'UPDATE_TASK',
  SHOW_TASK_DETAIL = 'SHOW_TASK_DETAIL',
  NOTE_UPDATE = 'NOTE_UPDATE',
  TODO_UPDATE = 'TODO_UPDATE',
}

export const MAX_CREDIT = 300;

export const MultiplayerServices = [
  {
    id: E_MultiplayerServiceName.InboxManagement,
    title: 'Proactively manage my inbox',
    subtitle: `You can customize this feature in the "Assistant setup" settings page.`,
    Icons: [GmailIcon],
    selected: true,
    disabled: true,
    scopes: [
      'https://www.googleapis.com/auth/gmail.modify',
      'https://www.googleapis.com/auth/contacts.readonly',
      'https://www.googleapis.com/auth/contacts.other.readonly',
    ],
  },
  {
    id: E_MultiplayerServiceName.DraftReply,
    title: 'Email drafts',
    subtitle: `Create draft replies to email threads on your behalf. When integrated with the calendar, it will provide your meeting availability. When meeting recording feature enabled, also assists with drafting follow ups to meetings with action items.`,
    Icons: [GmailIcon],
    selected: true,
    scopes: [
      'https://www.googleapis.com/auth/gmail.modify',
      'https://www.googleapis.com/auth/contacts.readonly',
      'https://www.googleapis.com/auth/contacts.other.readonly',
    ],
  },
  {
    id: E_MultiplayerServiceName.DailyPodcast,
    title: 'Daily podcast and briefing',
    subtitle:
      'Start off your weekdays with a personalized podcast that gets you up to speed on your schedule, important emails, newsletter updates, and events for you to consider. Also receive an end of day check-in.',
    Icons: [GmailIcon],
    selected: true,
    scopes: [
      'https://www.googleapis.com/auth/gmail.modify',
      'https://www.googleapis.com/auth/contacts.readonly',
      'https://www.googleapis.com/auth/contacts.other.readonly',
    ],
  },
  {
    id: E_MultiplayerServiceName.MeetingPrep,
    title: 'Prepare me for meetings',
    subtitle:
      'Delivers background research on external attendees and their organizations each morning and 15 minutes prior to each meeting. Also includes fun ice breakers to get the conversation started.',
    Icons: [GoogleCalendarIcon],
    selected: true,
    scopes: [
      'https://www.googleapis.com/auth/calendar.events',
      'https://www.googleapis.com/auth/calendar.readonly',
    ],
  },
  {
    id: E_MultiplayerServiceName.MeetingAssistant,
    title: 'Record and summarize meetings (beta)',
    subtitle: `You can customize this feature in the "Assistant setup" settings page.`,
    Icons: [GoogleCalendarIcon],
    disabled: true,
    selected: true,
    scopes: [
      'https://www.googleapis.com/auth/calendar.events',
      'https://www.googleapis.com/auth/calendar.readonly',
    ],
  },
  {
    id: E_MultiplayerServiceName.ActionItems,
    title: 'Track and remember action items (beta)',
    subtitle:
      'Automatically detect action items across emails and meetings and remind you of important milestones, deadlines, and event dates.',
    Icons: [GoogleCalendarIcon, GmailIcon],
    selected: true,
    scopes: [
      'https://www.googleapis.com/auth/calendar.events',
      'https://www.googleapis.com/auth/calendar.readonly',
      'https://www.googleapis.com/auth/gmail.modify',
      'https://www.googleapis.com/auth/contacts.readonly',
      'https://www.googleapis.com/auth/contacts.other.readonly',
    ],
  },
];
